import { Brand } from '@/components/layout/Brand'
import { Spinner } from '@/components/ui'
import { isDarkMode, useThemeStore } from '@/stores/themeStore'

export function SplashScreen() {
  const dark = isDarkMode(useThemeStore((state) => state.mode))

  return (
    <div className="grid min-h-dvh place-items-center bg-gradient-to-b from-[#e9eef5] to-[#f6f8fc] dark:from-[#0a2440] dark:via-[#0b1b2e] dark:to-[#04121f]">
      <div className="flex flex-col items-center gap-5">
        <Brand surface={dark ? 'dark' : 'light'} size="lg" />
        <Spinner className="text-fg-muted" />
      </div>
    </div>
  )
}
